import { useLazyGetUpdatedTranslationsQuery } from "../../../api/translationsAPI";
import { LangE } from "../../../models/enums";
import { useAppDispatch } from "../../../store/hooks";
import {
  setTranslatedStrings,
  switchLang,
} from "../../../store/slices/appSlice";

const STORAGE_KEY = "translations";

const useReactConsts = () => {
  const dispatch = useAppDispatch();
  const [getUpdatedTranslations] = useLazyGetUpdatedTranslationsQuery();

  const setReactConsts = async (lang: LangE) => {
    if (lang !== LangE.EN && lang !== LangE.HE) return;
    
    const storageTranslations = JSON.parse(localStorage.getItem(STORAGE_KEY));
    const lastUpdateDate = storageTranslations
      ? storageTranslations[lang]?.lastUpdateDate
      : undefined;

    const translations = await getUpdatedTranslations({
      lang,
      lastUpdateDate,
    });

    dispatch(switchLang(lang));

    if (translations.data) {
      // if lastUpdateDate is different and, therefore, response contains new translations
      // set new translations to redux store and locale storage
      dispatch(setTranslatedStrings(translations?.data.consts));

      const updatedTranslations = JSON.stringify({
        ...storageTranslations,
        [lang]: translations,
      });
      localStorage.setItem(STORAGE_KEY, updatedTranslations);
    } else {
      // set old translations from local storage to redux store
      dispatch(setTranslatedStrings(storageTranslations[lang].consts));
    }
  };

  return setReactConsts;
};

export default useReactConsts;
